module.exports = __webpack_public_path__ + "img/Retail5.d3f1ee84.png";